import React from 'react';
import { UiKit } from '@datavant/uikit';
import { VStack } from '@chakra-ui/react';

export const EpicModal = (props: { onClose: () => void; isOpen: boolean }) => {
    const ModalBody = (
        <VStack width={'100%'} alignItems={'left'}>
            <UiKit.Text.BodyRegularBold>
                To move forward with Autofulfill setup, please provide your practice's IT contact with the
                following information regarding implementation:
            </UiKit.Text.BodyRegularBold>
            <UiKit.Text.ExternalLink
                href="/df/Epic-Setup-Guide.pdf"
                text="Digital Fulfillment Requirements"
            />
            <UiKit.Text.BodyRegular>
                Our team will reach out with next steps once we are ready to proceed with implementation.
                Please reach out to requestmanager@datavant.com with any questions.
            </UiKit.Text.BodyRegular>
        </VStack>
    );

    const ModalFooter = (
        <UiKit.Chakra.VStack>
            <UiKit.Chakra.HStack w={'full'} justifyContent={'flex-end'} spacing={UiKit.consistency.buffer}>
                <UiKit.Button.Cancel text={'Close'} onClick={props.onClose} />
            </UiKit.Chakra.HStack>
        </UiKit.Chakra.VStack>
    );

    return (
        <UiKit.Modal
            title={'Continue Autofulfill Set Up'}
            bodyFragment={ModalBody}
            footerFragment={ModalFooter}
            onClose={props.onClose}
            isOpen={props.isOpen}
            size={'2xl'}
            fullScreen={false}
        />
    );
};
